import { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import LoginPage from "./components/LoginPage";
import HomeScreen from "./components/HomeScreen";
import { auth } from "./firebase/auth";

export default function App() {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    if (window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = undefined;
        const recaptchaContainer = document.getElementById("recaptcha-container");
        if (recaptchaContainer) recaptchaContainer.innerHTML = "";
      } catch (e) {
        console.warn("Failed to clear reCAPTCHA:", e);
      }
    }
  };

  return (
    <Router>
      {user ? <HomeScreen onLogout={handleLogout} /> : <LoginPage onLogin={() => {}} />}
    </Router>
  );
}